import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { RegionBaseService } from '../../services/region-base.service';
import { RegionType } from './region-type';
import { RegionSelectionType } from '../../types/property.types';

@Component({
  selector: 'df-region-selection',
  templateUrl: './region-selection.component.html',
  styleUrls: ['./region-selection.component.scss']
})
export class RegionSelectionComponent implements OnInit {
  @Input() set selectionType(val: any) {
    this._selectionType = val;
    this.resetOptions();
  }
  @Input() set regionEditInfo(val: any) {
    this.setRegionEditInfo(val);
  }
  @Input() set viewReadonly(val: any) {
    this.getViewReadonly(val);
  }

  options: { hasCity: boolean; hasDistrict: boolean } = {
    hasCity: true,
    hasDistrict: true
  };

  @Output() resultData: EventEmitter<any> = new EventEmitter();

  editData: any;
  provinceList: Region[] = [];
  cityList: Region[] = [];
  districtList: Region[] = [];

  isReadOnly: boolean;

  result: RegionType;
  provinceCode: any = null;
  cityCode: any = null;
  districtCode: any = null;

  specialRegion: any = {
    Honkong: '810000',
    Taiwan: '710000',
    Aomen: '820000',
    DongGuan: '441900',
    ZhongShan: '442000',
    JiaYuGuan: '620200'
  };

  private _selectionType: number;

  constructor(private regionService: RegionBaseService) {}

  ngOnInit() {
    this.result = {} as RegionType;
    this.regionService.getProvince().subscribe((res) => {
      this.provinceList = res;
    });
  }

  selectProvince(code: string, clear: boolean = true) {
    return new Promise((resolve) => {
      this.cityList = [];
      this.districtList = [];
      if (clear) {
        this.cityCode = null;
        this.districtCode = null;
        this.emitResultData('');
      }
      // ç­å¾provinceå¼è·åå°
      if (this.provinceCode) {
        this.result.provinceCode = code;
        const province = this.provinceList.find((s) => s.code === code);
        if (province) {
          this.result.province = province.name;
        }

        if (code === this.specialRegion.Aomen) {
          this.cityCode = this.result.cityCode = '';
          this.result.city = '';

          this.districtCode = this.result.districtCode = '';
          this.result.district = '';

          this.emitResultData(this.result);
          resolve();
          return;
        }
        if (this.options.hasCity) {
          this.regionService.getCitysByCode(code).subscribe((cityList) => {
            this.cityList = cityList;
            resolve();
          });
        } else {
          this.emitResultData(this.result);
          resolve();
        }
      }
    });
  }

  selectCity(code: string, clear: boolean = true) {
    return new Promise((resolve) => {
      this.districtList = [];
      if (clear) {
        this.districtCode = null;
        if (this.options.hasCity) {
          this.emitResultData('');
        }
      }

      if (this.cityCode) {
        this.result.cityCode = code;
        const city = this.cityList.find((s) => s.code === code);
        if (city) {
          this.result.city = city.name;
        }

        if (this.options.hasDistrict) {
          this.regionService.getCitysByCode(code).subscribe((res) => {
            this.districtList = res;
            resolve();
          });
        } else {
          if (this.options.hasCity) {
            this.emitResultData(this.result);
            resolve();
          }
        }
      }
    });
  }

  selectDistrict(code: string) {
    if (this.districtCode) {
      const district = this.districtList.find((s) => s.code === code);
      if (district) {
        this.result.district = district.name;
      }

      this.result.districtCode = code;
      if (this.options.hasDistrict) {
        this.emitResultData(this.result);
      }
    } else {
      if (this.options.hasDistrict) {
        this.emitResultData('');
      }
    }
  }

  emitResultData(e: any) {
    this.resultData.emit(e);
  }

  setRegionEditInfo(val: any) {
    if (val && Object.keys(val).length !== 0) {
      this.editData = val;

      const provinceKey = 'provinceCode';
      const provinceName = 'province';

      const cityKey = 'cityCode';
      const cityName = 'city';

      const districtKey = 'districtCode';
      const districtName = 'district';
      if (!this.result) {
        this.result = {} as RegionType;
      }

      for (const key in val) {
        if (val.hasOwnProperty(key)) {
          this.provinceCode = !val[provinceKey] ? null : val[provinceKey];
          this.cityCode = !val[cityKey] ? null : val[cityKey];
          this.districtCode = !val[districtKey] ? null : val[districtKey];

          this.result.province = !val[provinceName] ? '' : val[provinceName];
          this.result.city = !val[cityName] ? '' : val[cityName];
          this.result.district = !val[districtName] ? '' : val[districtName];
        }
      }

      if (val[provinceKey]) {
        this.selectProvince(val[provinceKey], false);
        if (val[provinceKey] !== this.specialRegion.Aomen) {
          if (val[cityKey]) {
            this.selectCity(val[cityKey], false);
            if (val[districtKey]) {
              this.selectDistrict(val[districtKey]);
            }
          }
        }
      }
    } else {
      this.provinceCode = null;
      this.cityCode = null;
      this.districtCode = null;
      this.districtList = [];
      this.cityList = [];
    }
  }

  resetOptions() {
    if (this._selectionType) {
      this.options = {
        // tslint:disable-next-line: no-bitwise
        hasCity: !!(this._selectionType & RegionSelectionType.City),
        // tslint:disable-next-line: no-bitwise
        hasDistrict: !!(this._selectionType & RegionSelectionType.District)
      };
    }
  }

  getViewReadonly(val: any) {
    this.isReadOnly = val;
  }
}

export interface Region {
  code: string;
  name: string;
  id: string;
  parentId: string;
}
